import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import ChatLayer from "../components/ChatLayer";

const Chat = () => {
  const [chatEnabled, setChatEnabled] = useState(true);

  useEffect(() => {
    document.title = "Chat Messages";
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      setChatEnabled(user.chat_enabled !== 0 && user.chat_enabled !== false);
    } catch {
      setChatEnabled(true);
    }
  }, []);

  if (!chatEnabled) {
    return (
      <MasterLayout>
        <div className="card p-4 text-center">
          <h5 className="mb-2">Chat is disabled</h5>
          <p className="text-muted mb-3">
            Enable chat messages from Settings to use the inbox.
          </p>
          <Link to="/settings" className="btn btn-success">
            Go to Settings
          </Link>
        </div>
      </MasterLayout>
    );
  }

  return (
    <MasterLayout hideFooter>
      <ChatLayer />
    </MasterLayout>
  );
};

export default Chat;
